import { useContent } from "../ContentContext";
import DarkFooter from "../sections/DarkFooter";

const ContactPage = () => {
  const content = useContent();

  return (
    <div className="bg-dark text-light h-screen flex flex-col">
      {/* Content Section */}
      <section className="relative h-full text-center bg-light text-white flex-grow">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/videos/contactpage.png"
        >
          <source src="/videos/contactpage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay Layer */}
        <div className="absolute inset-0 bg-gradient-to-b from-dark/80 via-dark/80 to-dark"></div>

        {/* Overlay Content */}
        <div className="relative text-1xl sm:text-2xl max-w-4xl mx-auto flex flex-col items-center justify-center h-full">
          {/* Text Content */}
          <p className="uppercase text-2xl tracking-wide font-garet relative">
            {content.contactpage.subtitle}
          </p>
          <h1 className="text-7xl my-4 font-bodoni relative">
            {content.contactpage.title}
          </h1>

          {content.contactinfo.locations.map((location, index) => (
            <div key={index}>
              <h3 className="font-poppins font-bold uppercase">{location[0]}</h3>
              <p className="font-garet">
                {location[1]}
                <br />
                {location[2]}
                <br />
                {location[3]}
              </p>
              <br />
            </div>
          ))}

          {/* Phone */}
          <div>
            <h3 className="font-poppins font-bold uppercase">Phone</h3>
            <a
              href={`tel:+1${content.contactinfo.phone}`}
              className="font-garet"
            >
              {content.contactinfo.phone}
            </a>
          </div>
          <br />
          {/* Email */}
          <div>
            <h3 className="font-poppins font-bold uppercase">Email</h3>
            <a
              href={`mailto:${content.contactinfo.email}`}
              className="font-garet"
            >
              {content.contactinfo.email}
            </a>
          </div>
        </div>
      </section>


        {DarkFooter()}
    </div>
  );
};

export default ContactPage;
